import { Injectable } from '@angular/core';

import { map } from 'rxjs';

import { PaymentPageComponent } from './payment-page.component';

@Injectable({ providedIn: 'root' })
export class PaymentPageDeactivateGuard {
  canDeactivate(component: PaymentPageComponent) {
    return component?.isPartiallyPaid$.pipe(
      map((isPartiallyPaid) => !isPartiallyPaid || component.internalStep === 'variant')
    );
  }
}
